var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifestyleSliderSleepIconWhite2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117.3 74.7",
    style: {
      enableBackground: "new 0 0 117.3 74.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_144_2_",
    transform: "translate(-17.222 -37.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_282_2_",
    className: "st0",
    d: "M96.2,60.4l2.6-0.4L95,63.9c-0.5,0.4-0.5,1.1-0.2,1.5c0.2,0.4,0.7,0.7,1.2,0.7h0.3 l6.6-1.2c0.7-0.1,1.2-0.8,1.1-1.5s-0.8-1.2-1.5-1.1l-2.4,0.5l3.7-3.8c0.3-0.4,0.4-1,0.3-1.5c-0.3-0.5-0.9-0.8-1.4-0.7l-6.6,1 c-0.7,0.1-1.2,0.8-1.2,1.5c0,0.6,0.5,1.1,1.2,1.1C96,60.4,96.1,60.4,96.2,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_283_2_",
    className: "st0",
    d: "M132.7,79.3c-0.9,0.1-1.9,0.4-2.7,0.8c-1.1,0.5-2.2,0.9-3.4,1.1 c-0.2,0-0.4-0.1-0.6-0.2c-1.6-1.1-2.9-2.5-4-4.1c-3.2-5.4-9.1-8.6-15.4-8.5c-1.9,0-5-0.1-8.7-0.2c-6.1-0.1-13.8-0.3-20.9-0.3 c-10.3,0-16.8,0.4-19.6,1c-5.9,1.4-8.6,4.7-11.6,8.1c-0.7,0.9-1.5,1.8-2.4,2.8c-0.5,0.4-1.1,0.7-1.7,0.6c-1.5-0.1-2.9-0.5-4.3-1.1 c-0.9-0.4-1.8-0.7-2.8-0.7c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.6-0.5,1.5-0.2,2.2c0.6,2,2.5,3.8,4.3,5.6c1.4,1.4,3.1,3,3.4,4.1l0.1,0.4 c4.5,16.5,11.9,20.1,17.4,20.1c0.5,0,1.1,0.1,1.6,0.1c0.6,0,1.3,0,1.9-0.1h0.3c3.9-0.4,7.7-1.7,11-3.9c0.6-0.4,1.3-0.9,2-1.4 c2.8-2.1,6.4-4.6,9.1-4.7h0.1c2.2,0,5.3,2.1,8,3.9c1.3,0.9,2.6,1.7,3.8,2.3c4.7,2.3,8.6,3.5,12.6,3.6h0.4c8.6,0,14.5-7.3,16.5-14.4 c0.2-0.6,0.3-1.2,0.4-1.9c0.5-2.4,1.1-4.7,2.8-6.1c0.5-0.5,1.1-1,1.7-1.3c2.3-1.8,4.5-3.5,4.4-6.6c0.2-1-0.5-1.9-1.5-2 C132.9,79.3,132.8,79.3,132.7,79.3L132.7,79.3z M128.5,85.4c-0.5,0.4-1.2,0.9-1.8,1.4c-2.4,2.1-3.1,5-3.7,7.6 c-0.2,0.6-0.3,1.2-0.4,1.8c-1.5,5.7-6,12.3-13.7,12.3h-0.4c-4-0.2-7.9-1.3-11.3-3.3c-1-0.5-2.2-1.3-3.5-2.2 c-3.1-2.1-6.5-4.3-9.6-4.3h-0.3c-3.6,0.1-7.6,3-10.7,5.2c-0.7,0.4-1.3,1-1.9,1.3c-2.9,1.9-6.1,3-9.5,3.4h-2.2c-0.5,0-1,0-1.4,0.1 c-4.4-0.1-10.4-3.3-14.4-18l-0.1-0.4c-0.5-1.9-2.3-3.6-4.2-5.5c-1-0.9-1.9-1.8-2.7-2.8c1.7,0.7,3.4,1.1,5.2,1.3 c1.5,0.1,2.9-0.5,3.9-1.6c0.9-1,1.7-2,2.5-2.9c2.8-3.3,5-5.9,10-7.1c2.5-0.6,8.9-0.9,18.9-0.9c7.1,0,14.7,0.2,20.8,0.3 c3.9,0.1,6.9,0.2,8.8,0.2c5.3-0.1,10.2,2.6,12.9,7.2c1.2,2,2.8,3.7,4.8,4.9c0.7,0.4,1.5,0.7,2.2,0.6c1.6-0.1,3.2-0.6,4.6-1.3h0.1 C130.5,83.8,129.5,84.6,128.5,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_284_2_",
    className: "st0",
    d: "M67.5,101c-1.1,0.5-2.2,1-3.1,1.4c-0.7,0.3-1.1,1.1-0.8,1.9c0.2,0.5,0.8,0.9,1.3,0.9 c0.2,0,0.4,0,0.5-0.1c1.2-0.5,2.3-1,3.4-1.5c0.7-0.4,1-1.3,0.6-2S68.2,100.6,67.5,101L67.5,101L67.5,101z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_285_2_",
    className: "st0",
    d: "M115.1,81.4c0.3,0.6,0.6,1.2,0.8,1.8c0.2,0.6,0.7,1,1.3,1c0.2,0,0.4,0,0.5-0.1 c0.8-0.3,1.2-1.1,0.9-1.9c-0.3-0.8-0.6-1.6-1.1-2.3c-0.3-0.5-0.6-0.9-1.1-1.3c-0.6-0.6-1.5-0.5-2.1,0s-0.5,1.5,0,2.1c0,0,0,0,0,0 C114.7,81,114.9,81.2,115.1,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_286_2_",
    className: "st0",
    d: "M67.6,75.5c0-0.8-0.6-1.4-1.4-1.4c0,0,0,0,0,0c-1.3,0-2.6,0-3.6,0.1 c-0.8,0-1.5,0.7-1.4,1.5c0,0.8,0.6,1.4,1.4,1.4c0,0,0,0,0,0c1,0,2.2,0,3.6-0.1C67,77,67.6,76.3,67.6,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_287_2_",
    className: "st0",
    d: "M73.3,76.9h3.6c0.8,0,1.4-0.6,1.4-1.4c0,0,0,0,0,0c0-0.8-0.5-1.4-1.3-1.4 c0,0-0.1,0-0.1,0h-3.6c-0.8,0-1.4,0.6-1.4,1.4C71.9,76.3,72.5,76.9,73.3,76.9C73.3,76.9,73.3,76.9,73.3,76.9L73.3,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_288_2_",
    className: "st0",
    d: "M47.6,90c0.6,0,1.2-0.4,1.3-1c0.3-1.1,0.8-2.1,1.3-3.1c0.4-0.7,0.1-1.6-0.6-2 s-1.6-0.1-2,0.6l0,0c-0.6,1.1-1.1,2.3-1.4,3.5c-0.3,0.7,0.1,1.5,0.8,1.8c0,0,0.1,0,0.1,0C47.2,90,47.4,90.1,47.6,90z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_289_2_",
    className: "st0",
    d: "M49.8,95.2c-0.2-0.7-1.1-1.1-1.8-0.9c-0.7,0.2-1.1,1.1-0.9,1.8l0,0 c0.4,1.2,0.9,2.4,1.5,3.5c0.3,0.4,0.7,0.7,1.3,0.7c0.2,0,0.5-0.1,0.7-0.2c0.7-0.3,1-1.2,0.6-1.8c0,0,0-0.1-0.1-0.1 C50.6,97.2,50.1,96.2,49.8,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_290_2_",
    className: "st0",
    d: "M56.4,78.2c0.7-0.4,0.8-1.3,0.4-2c-0.4-0.6-1.3-0.8-1.9-0.4c-1.1,0.7-2.1,1.6-3,2.6 c-0.5,0.6-0.5,1.5,0.1,2c0,0,0,0,0,0c0.3,0.2,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.4C54.8,79.5,55.6,78.8,56.4,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_291_2_",
    className: "st0",
    d: "M58.1,103.4c-1,0-1.9-0.3-2.7-0.8c-0.7-0.4-1.6-0.2-2,0.5c-0.4,0.7-0.2,1.6,0.5,2 c1.3,0.7,2.7,1.1,4.1,1.2c0.8,0,1.4-0.6,1.4-1.4C59.6,104.1,58.9,103.4,58.1,103.4L58.1,103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_292_2_",
    className: "st0",
    d: "M76.7,95.5c-1.1,0.6-2.1,1.2-3.1,1.9c-0.7,0.4-0.9,1.2-0.5,1.9c0,0,0,0.1,0.1,0.1 c0.3,0.4,0.7,0.7,1.3,0.7c0.3,0,0.6-0.1,0.8-0.2c1.3-0.7,2.2-1.3,3.1-1.8c0.7-0.3,1-1.2,0.6-1.8c0,0,0-0.1-0.1-0.1 C78.3,95.4,77.4,95.2,76.7,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_293_2_",
    className: "st0",
    d: "M117.2,98.6c-0.7-0.5-1.6-0.3-2.1,0.3c0,0,0,0,0,0c-0.7,0.9-1.4,1.7-2.2,2.4 c-0.6,0.5-0.7,1.4-0.1,2c0,0,0,0,0,0c0.3,0.3,0.7,0.5,1.1,0.4c0.4,0,0.7-0.1,1-0.4c1-0.9,1.8-1.8,2.6-2.9 C118,100,117.9,99.1,117.2,98.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_294_2_",
    className: "st0",
    d: "M109.5,75c-1.4-0.4-2.8-0.8-3.6-1c-0.8-0.2-1.5,0.3-1.7,1.1 c-0.2,0.8,0.3,1.5,1.1,1.7l0,0c1.1,0.2,2.2,0.5,3.3,0.9c0.1,0.1,0.3,0.1,0.4,0.1c0.6,0,1.2-0.4,1.3-1c0.3-0.7,0-1.4-0.7-1.7 C109.6,75.1,109.6,75,109.5,75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_295_2_",
    className: "st0",
    d: "M107.8,103c-0.8-0.2-2.1-0.4-3.4-0.8c-0.8-0.2-1.6,0.2-1.8,1s0.2,1.6,1,1.8 c1.4,0.4,2.7,0.6,3.6,0.8h0.3c0.7,0,1.3-0.5,1.4-1.2C109,103.9,108.5,103.1,107.8,103z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_296_2_",
    className: "st0",
    d: "M118.8,88.2c-0.8,0.1-1.4,0.8-1.3,1.6c0,0,0,0,0,0c0.1,1.1,0.2,2.1,0.2,3.1v0.4 c0,0.8,0.6,1.5,1.4,1.5c0.8,0,1.4-0.6,1.4-1.4c0,0,0,0,0,0V93c0-1.1-0.1-2.2-0.2-3.4c0-0.8-0.6-1.4-1.4-1.4 C118.9,88.2,118.8,88.2,118.8,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_297_2_",
    className: "st0",
    d: "M98.4,73.9h-3.6c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4c0,0,0,0,0,0h3.6 c0.8,0,1.4-0.6,1.4-1.4C99.9,74.5,99.2,73.9,98.4,73.9C98.4,73.9,98.4,73.9,98.4,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_298_2_",
    className: "st0",
    d: "M87.6,73.9H84c-0.8,0-1.4,0.6-1.4,1.4c0,0.8,0.6,1.4,1.4,1.4h3.6 c0.8,0,1.4-0.6,1.4-1.4C89.1,74.5,88.4,73.9,87.6,73.9C87.6,73.9,87.6,73.9,87.6,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_299_2_",
    className: "st0",
    d: "M88.1,95.1c-1.4-0.5-2.6-1-3.5-1.3c-0.8-0.2-1.6,0.2-1.8,1s0.2,1.6,1,1.8 c0.8,0.3,1.9,0.6,3.2,1.2c0.2,0.1,0.4,0.1,0.5,0.1c0.6,0,1.1-0.4,1.3-0.9C89.2,96.2,88.8,95.4,88.1,95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_300_2_",
    className: "st0",
    d: "M98,99.7c-0.8-0.4-2-1-3.2-1.6c-0.7-0.3-1.6,0-2,0.7s0,1.6,0.7,2 c1.3,0.6,2.3,1.2,3.2,1.5c0.2,0.1,0.4,0.2,0.6,0.2c0.6,0,1.1-0.3,1.3-0.8C99,100.9,98.7,100,98,99.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyleSliderSleepIconWhite2);
export default __webpack_public_path__ + "static/media/lifestyle_slider_sleep_icon_white_2.ac312a3d.svg";
export { ForwardRef as ReactComponent };